import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Sheet, SheetContent, SheetHeader, SheetTitle } from "@/components/ui/sheet";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { Button } from "@/components/ui/button";
import { Pencil } from "lucide-react";
import { fmtTL, fmtDate, fmtNum } from "@/lib/utils";

export default function TimesheetDetail({ record, opts, onClose, onEdit }) {
  const [history, setHistory] = useState([]);
  useEffect(() => {
    if (record) api.get("/timesheets", { params: { worker: record.worker_name, limit: 60 } }).then(r => setHistory(r.data.filter(t => t.worker_name === record.worker_name)));
  }, [record]);
  if (!record) return null;
  const tot = history.reduce((a, t) => ({ h: a.h + t.hours_worked, o: a.o + t.overtime_hours, c: a.c + (t.cost || 0) }), { h: 0, o: 0, c: 0 });
  const fields = [
    ["Tarih", fmtDate(record.work_date)], ["Şantiye", record.project_name], ["Firma", record.firm_name || "Kendi personelimiz"],
    ["Görev", opts.roles?.[record.role] || record.role], ["Durum", opts.statuses?.[record.status] || record.status],
    ["İş Kalemi", record.work_item || "—"], ["Blok / Mahal", record.block || "—"], ["Çalışma / Mesai", `${fmtNum(record.hours_worked)} sa / ${fmtNum(record.overtime_hours)} sa`],
    ["Yevmiye", fmtTL(record.daily_wage)], ["İşçilik Maliyeti", fmtTL(record.cost)],
  ];

  return (
    <Sheet open onOpenChange={o => !o && onClose()}>
      <SheetContent className="w-full sm:max-w-2xl overflow-y-auto" data-testid="ts-detail">
        <SheetHeader><SheetTitle className="font-display text-xl">{record.worker_name}</SheetTitle></SheetHeader>
        <div className="flex justify-end mt-2"><Button size="sm" variant="outline" onClick={() => onEdit(record)} data-testid="ts-detail-edit"><Pencil className="w-4 h-4 mr-1" /> Düzenle</Button></div>
        <div className="grid grid-cols-2 gap-3 mt-3">
          {fields.map(([k, v]) => <div key={k} className="rounded-lg border border-border p-3"><div className="text-xs text-muted-foreground">{k}</div><div className="text-sm font-semibold mt-0.5">{v}</div></div>)}
        </div>
        <div className="rounded-lg border border-border p-3 mt-3"><div className="text-xs text-muted-foreground">Not Detayı</div>
          <div className="text-sm mt-1 whitespace-pre-wrap" data-testid="ts-detail-notes">{record.notes || "—"}</div></div>
        <h4 className="font-semibold mt-6 mb-2 text-sm">Çalışanın son kayıtları ({history.length}) · {fmtNum(tot.h)} sa · {fmtNum(tot.o)} sa mesai · {fmtTL(tot.c)}</h4>
        <Table>
          <TableHeader><TableRow><TableHead>Tarih</TableHead><TableHead>Şantiye</TableHead><TableHead>İş Kalemi</TableHead><TableHead className="text-right">Saat</TableHead><TableHead className="text-right">Maliyet</TableHead></TableRow></TableHeader>
          <TableBody>{history.map(t => (
            <TableRow key={t.id} className={t.id === record.id ? "bg-amber-500/10" : ""}>
              <TableCell className="text-xs">{fmtDate(t.work_date)}</TableCell><TableCell className="text-xs">{t.project_name}</TableCell>
              <TableCell className="text-xs">{t.work_item || "—"}</TableCell>
              <TableCell className="text-right font-mono-nums text-xs">{fmtNum(t.hours_worked)}+{fmtNum(t.overtime_hours)}</TableCell>
              <TableCell className="text-right font-mono-nums text-xs">{fmtTL(t.cost)}</TableCell>
            </TableRow>
          ))}</TableBody>
        </Table>
      </SheetContent>
    </Sheet>
  );
}
